document.addEventListener("DOMContentLoaded", () => {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  const cursor = document.createElement("div");
  cursor.className = "cursor";
  document.body.appendChild(cursor);

  // Track cursor
  document.addEventListener("mousemove", (e) => {
    cursor.style.top = `${e.clientY}px`;
    cursor.style.left = `${e.clientX}px`;
  });

  // ONLY elements explicitly marked may trigger cursor state
  document.querySelectorAll("[data-cursor]").forEach((el) => {
    const mode = el.getAttribute("data-cursor"); // "", "strong"

    el.addEventListener("mouseenter", () => {
      cursor.classList.add("is-hover");
      if (mode === "strong") cursor.classList.add("is-strong");
    });

    el.addEventListener("mouseleave", () => {
      cursor.classList.remove("is-hover", "is-strong");
    });
  });
});
